import React from 'react';
import { TagOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Label, LabelEntityType } from '../../types/labels';
import AssetsLabelsManagementPage from '../assets_labels_management_page/AssetsLabelsManagementPage';

type AssetsLabelCreationButtonProps = {
	targetCollectionName: LabelEntityType;
	// Assets table collection + router history, so deleting a label can unpin it from an
	// active Labels filter and clear it from the URL.
	listTargetCollectionName?: string;
	history?: any;
	onLabelCountClick?: (label: Label) => void;
	onLabelsCatalogueSaved?: () => void | Promise<void>;
};

export default function AssetsLabelCreationButton({
	targetCollectionName,
	listTargetCollectionName,
	history,
	onLabelCountClick,
	onLabelsCatalogueSaved,
}: AssetsLabelCreationButtonProps): React.ReactElement {
	const [drawerOpen, setDrawerOpen] = React.useState(false);

	const handleLabelCountClick = (label: Label) => {
		setDrawerOpen(false);
		if (onLabelCountClick) onLabelCountClick(label);
	};

	return (
		<div>
			<Button
				size="large"
				icon={<TagOutlined translate="" />}
				onClick={() => setDrawerOpen(true)}
				className="shrink-0"
			/>
			{drawerOpen ? (
				<AssetsLabelsManagementPage
					onClose={() => setDrawerOpen(false)}
					targetCollectionName={targetCollectionName}
					listTargetCollectionName={listTargetCollectionName}
					history={history}
					onLabelCountClick={onLabelCountClick ? handleLabelCountClick : undefined}
					onLabelsCatalogueSaved={onLabelsCatalogueSaved}
				/>
			) : null}
		</div>
	);
}
